import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Tech({ idVariant = '', className }: Props) {
  return (
    <IconBase name="tech" w={80} className={className}>
      <path d="M51 20V8" stroke="currentColor" strokeMiterlimit="10"/>
      <path d="M28 20V8" stroke="currentColor" strokeMiterlimit="10"/>
      <path d="M34.6 50.94V60H35.9998H44.38V50.94L44.63 50.8C44.75 50.72 56.99 43.38 56.99 36.02V20H21.99V36.02C21.99 43.38 34.23 50.73 34.35 50.8L34.6 50.94Z" stroke="currentColor"/>
      <path d="M17 20H62.5" stroke="currentColor" strokeMiterlimit="10"/>
      <path d="M40 72V60" stroke="currentColor" strokeMiterlimit="10"/>
    </IconBase>
  )
}

export default Tech
